export default __webpack_public_path__ + "static/media/QA&QC.13a5a210.png";